import { render, staticRenderFns } from "./chartjs.vue?vue&type=template&id=66694b2b&"
import script from "./chartjs.vue?vue&type=script&lang=js&"
export * from "./chartjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports